import { render } from "./CertDetailSept2022Page.vue?vue&type=template&id=29ec432c"
import script from "./CertDetailSept2022Page.vue?vue&type=script&lang=js"
export * from "./CertDetailSept2022Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__